/**
 * changement-adresse-accesd
 *
 * Contact: DPSL_UNICODES@desjardins.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface InfosCarte {
  /**
   * Nom de produit
   */
  descriptionCourte: string;
  /**
   * Numero de carte tokenise
   */
  numeroCarte: string;
  /**
   * Le type de carte
   */
  typeCarte: InfosCarteTypeCarteEnum;

  reseau: TypeReseauEnum;
}
export enum InfosCarteTypeCarteEnum {
  ORDINAIRE = 'ordinaire',
  PREPAYEE = 'prepayee',
  AFFAIRE = 'affaire',
  PRIVATIVE = 'privative',
  ASSOCIATIVE = 'associative',
  COAST = 'coast',
}

export enum TypeReseauEnum {
  VISA = 'Visa',
  MASTERCARD = 'Mastercard',
}
